export const CART_TOP_MESSAGES_HASH = "POSITION_TOP";
